import script from "./BaseSearchGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseSearchGroup.vue?vue&type=script&lang=ts&setup=true"

import "./BaseSearchGroup.vue?vue&type=style&index=0&id=53ebf864&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53ebf864"]])

export default __exports__